import axios from "axios";
import axiosInstance from "../configuration/request";

/**
 * Reverse geocode lat/lng to address fields using Google Maps Geocoder.
 * Returns { addressLine1, landmark, city, state, zip } or null if unavailable.
 */
export const reverseGeocode = (lat, lng) => {
  return new Promise((resolve) => {
    if (typeof window === "undefined" || !window.google?.maps?.Geocoder) {
      resolve(null);
      return;
    }
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status !== "OK" || !results?.[0]) {
        resolve(null);
        return;
      }
      const components = results[0].address_components || [];
      const get = (type) => components.find((c) => c.types.includes(type));
      const streetNumber = get("street_number")?.long_name || "";
      const route = get("route")?.long_name || "";
      const subpremise = get("subpremise")?.long_name || "";
      const premise = get("premise")?.long_name || "";
      const locality = get("locality")?.long_name || get("sublocality")?.long_name || get("sublocality_level_1")?.long_name || "";
      const state = get("administrative_area_level_1")?.short_name || "";
      const zip = get("postal_code")?.long_name || "";

      const addressLine1 = [streetNumber, route].filter(Boolean).join(" ") || results[0].formatted_address?.split(",")?.[0]?.trim() || "";
      const landmark = subpremise || premise || "";

      resolve({
        addressLine1: addressLine1 || undefined,
        landmark: landmark || undefined,
        city: locality || undefined,
        state: state || undefined,
        zip: zip || undefined,
      });
    });
  });
};

export const getLatLngFromZip = async (zip) => {
  
  try {
    const res = await axiosInstance.get(`/customer/users/zip-coordinated?zip=${zip}`);
    if (res.data) {
      return { latitude: res?.data?.center?.lat, longitude: res?.data?.center?.lng };
    } else {
      console.error("Geocoding error:", res.data.status);
      return null;
    }
  } catch (error) {
    console.error("Error fetching lat/lng:", error);
    return null;
  }
};

export async function buildAddressPayload({ 
  formData, 
  mode, 
  originalZip, 
  addresse, 
  showSnackbar 
}) {
  let latlong;

  if (formData.coordinates) {
    // User picked point on map
    latlong = {
      latitude: formData.coordinates.lat,
      longitude: formData.coordinates.lng,
      is_deleted: false,
    };
  } else {
    const isEdit = mode === "edit";
    const zipChanged = isEdit ? formData.zip !== originalZip : true;

    if (!isEdit || zipChanged) {
      // New or zip changed → always fetch fresh latlong
      latlong = await getLatLngFromZip(formData.zip);
      if (!latlong) {
        showSnackbar(
          "Failed to get location from zip code. Please pin point on map.",
          "error"
        );
        return null;
      }
    } else if (isEdit && !zipChanged) {
      if (addresse?.latlong?.latitude && addresse?.latlong?.longitude) {
        latlong = addresse.latlong;
      } else {
        latlong = await getLatLngFromZip(formData.zip);
        if (!latlong) {
          showSnackbar(
            "Failed to get location from zip code. Please pin point on map.",
            "error"
          );
          return null;
        }
      }
    }
  }

  return {
    house_no: formData.addressLine1,
    street_address: formData.addressLine2,
    landmark: formData.landmark,
    city: formData.city,
    state: formData.state,
    zipcode: formData.zip,
    latlong,
  };
}


export async function buildCoordinatesPayload({ 
  formData, 
  mode, 
  originalZip, 
  addresse, 
  showSnackbar 
}) {
  let latlong;

  if (formData.coordinates) {
    // User picked point on map
    latlong = {
      latitude: formData.coordinates.lat,
      longitude: formData.coordinates.lng,
    };
  } else {
    const isEdit = mode === "edit";
    const zipChanged = isEdit ? formData.zip !== originalZip : true;

    if (!isEdit || zipChanged) {
      // New or zip changed → always fetch fresh latlong
      latlong = await getLatLngFromZip(formData.zip);
      if (!latlong) {
        showSnackbar(
          "Failed to get location from zip code. Please pin point on map.",
          "error"
        );
        return null;
      }
    } else if (isEdit && !zipChanged) {
      if (addresse?.latlong?.latitude && addresse?.latlong?.longitude) {
        latlong = {
          latitude: addresse.latlong.latitude,
          longitude: addresse.latlong.longitude,
        };
      } else {
        latlong = await getLatLngFromZip(formData.zip);
        if (!latlong) {
          showSnackbar(
            "Failed to get location from zip code. Please pin point on map.",
            "error"
          );
          return null;
        }
      }
    }
  }

  return latlong;
}
